module.exports = __webpack_public_path__ + "img/container.883aacd.svg";